/**
 * TANDA I (B3) — EL CIERRE DEL AVISO "TE QUEDASTE SIN CRÉDITOS", POR EVENTO.
 *
 * LA FIRMA DE CARLOS: el banner de créditos agotados gana una X y esa X lo calla
 * para ESE evento, no para siempre.
 *
 * QUÉ ES UN "EVENTO" AQUÍ: el CICLO DE CRÉDITOS, identificado por
 * `usage.credit_reset_date` — la misma fecha que el Panel ya pinta en la cuenta
 * regresiva de reseteo. Es la elección natural porque es exactamente lo que hace
 * al aviso volverse falso: cuando los créditos se resetean, el ciclo cambia, el
 * cierre viejo deja de aplicar y un nuevo agotamiento es un aviso NUEVO que sí
 * se ve. Cerrar no puede costarte enterarte el mes que viene.
 *
 * POR QUÉ UN SOLO VALOR Y NO UN CONJUNTO (la diferencia con COS-31): el aviso de
 * pendientes anuncia un conjunto de grupos que crece y mengua, así que su
 * identidad es ese conjunto. Aquí el aviso anuncia UN hecho —te quedaste en
 * cero— dentro de UN ciclo, así que la identidad es el ciclo y basta guardar
 * cuál se cerró. Eso trae gratis la autolimpieza que COS-31 tuvo que cablear
 * aparte: al cambiar de ciclo el valor guardado deja de casar y el cierre muere
 * solo, sin poder crecer sin límite ni degenerar en "para siempre".
 *
 * SI NO HAY `credit_reset_date` (dato ausente o plan sin ciclo): NO se persiste
 * nada y el aviso se comporta como hoy. Mismo criterio que el resto de la casa:
 * ante la duda, el aviso se ve. Y el mismo try/catch de siempre — en modo
 * privado se degrada a "no hay cierre guardado", jamás a un error.
 *
 * POR APARATO, no por cuenta, igual que `sb_pending_banner_dismissed`.
 */
const ZERO_CREDITS_DISMISSED_KEY = 'sb_zero_credits_dismissed';

/** El ciclo cerrado, o null si no hay cierre vigente. */
export function readZeroCreditsDismissal() {
  try {
    const raw = localStorage.getItem(ZERO_CREDITS_DISMISSED_KEY);
    if (!raw) return null;
    // Cualquier cosa que no sea una cadena no puede silenciar el aviso.
    return typeof raw === 'string' && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

/** Persiste el ciclo en el que se cerró el aviso. */
export function saveZeroCreditsDismissal(cycleId) {
  if (!cycleId) return;
  try {
    localStorage.setItem(ZERO_CREDITS_DISMISSED_KEY, String(cycleId));
  } catch { /* modo privado: el aviso simplemente no se silencia */ }
}

export function clearZeroCreditsDismissal() {
  try { localStorage.removeItem(ZERO_CREDITS_DISMISSED_KEY); } catch { /* ídem */ }
}

/**
 * La identidad del evento a partir de `usage`. Devuelve null cuando no hay ciclo
 * que nombrar — y sin identidad no hay cierre posible, que es la degradación
 * segura (el aviso se ve).
 */
export function zeroCreditsCycleId(usage) {
  if (!usage) return null;
  const reset = usage.credit_reset_date;
  return reset ? String(reset) : null;
}

/**
 * ¿El aviso de ESTE ciclo ya se cerró? Función PURA: silenciado sólo si hay
 * cierre guardado, hay ciclo identificable, y son el mismo.
 */
export function zeroCreditsIsSilenced(cycleId, dismissed) {
  if (!dismissed || !cycleId) return false;
  return dismissed === cycleId;
}

// Exportado para tests: fija el nombre único y constante de la llave.
export const _ZERO_CREDITS_DISMISSED_KEY = ZERO_CREDITS_DISMISSED_KEY;
